'use client';

import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useState } from 'react';

import {
  safeSessionStorageGetItem,
  safeSessionStorageSetItem,
} from '@onyx/client-storage';

type ListingParamsContextValue = {
  listingUrl: string | null;
  setListingUrl: (url: string) => void;
};

export const storageKey = 'help-hub:listing-url';

const ListingParamsContext = createContext<ListingParamsContextValue>({
  listingUrl: null,
  setListingUrl: () => undefined,
});

const readStoredUrl = (): string | null => {
  const [value] = safeSessionStorageGetItem(storageKey);
  return value;
};

export const ListingParamsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [listingUrl, setListingUrlState] = useState<string | null>(
    readStoredUrl
  );

  const setListingUrl = useCallback((url: string) => {
    safeSessionStorageSetItem(storageKey, url);
    setListingUrlState(url);
  }, []);

  return (
    <ListingParamsContext.Provider value={{ listingUrl, setListingUrl }}>
      {children}
    </ListingParamsContext.Provider>
  );
};

export const useListingParams = (): ListingParamsContextValue =>
  useContext(ListingParamsContext);
